import ProductCard from "../product-card/product-card";
import "./card-rail-style.scss";

//橫向卡片列
//
//  純手機版，所以只有一種行為：手指橫向滑動，右邊露出下一張的一角
//  當作「還有更多」的提示。
//
//  刻意不做左右箭頭：手機有滑動手勢，箭頭只會佔位置又蓋住卡片。
//  也不用 carousel 套件 —— 原生 overflow-x + scroll-snap 就夠了。
//
//  perView：一次看到幾張。
//    小數（預設 2.3）= 右邊刻意露出一角，暗示「還有更多」，項目多時用。
//    整數          = 卡片剛好填滿欄寬、兩側留白對齊內文，項目少時用。
//  項目少卻用小數會變成「最後一張被切在螢幕邊緣」——
//  那不是提示，滑到底就沒了，只會讓人以為版面壞掉。
const CardRail = ({ items, size = "md", perView = 2.3 }) => (
  <div className="rail no-scrollbar" style={{ "--rail-per-view": perView }}>
    {items.map((item) => (
      <div className="rail__item" key={item.id}>
        <ProductCard item={item} size={size} />
      </div>
    ))}
  </div>
);

export default CardRail;
